// Smart Import API 클라이언트

import { api } from './api'
import type {
  ApplyResult, Estimate, ImportRecord, ImportTargetKind, Quota,
} from '../types/imports'

interface UploadOpts {
  targetKind: ImportTargetKind
  sourceType?: string
  eduCode?: string | null
  eduSessionId?: string | null
  customEduTitle?: string | null
  files: File[]
}

export interface QuotaBundle {
  plan_code: string
  migration: Quota
  msds: Quota
}

export const importsApi = {
  // 풀이 둘이다(자료 가져오기 / MSDS). target_kind 를 주면 그 자료가 쓰는 풀을 돌려준다.
  quota: (targetKind?: string) =>
    api.get<Quota>('/imports/quota',
      targetKind ? { params: { target_kind: targetKind } } : undefined).then(r => r.data),
  quotaAll: () => api.get<QuotaBundle>('/imports/quota/all').then(r => r.data),

  estimate: (siteId: string, targetKind: ImportTargetKind, files: File[]) => {
    const fd = new FormData()
    fd.append('target_kind', targetKind)
    for (const f of files) fd.append('files', f)
    return api.post<Estimate>(
      `/imports/sites/${siteId}/estimate`, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then(r => r.data)
  },

  upload: (siteId: string, opts: UploadOpts) => {
    const fd = new FormData()
    fd.append('target_kind', opts.targetKind)
    if (opts.sourceType) fd.append('source_type', opts.sourceType)
    if (opts.eduCode) fd.append('edu_code', opts.eduCode)
    if (opts.eduSessionId) fd.append('edu_session_id', opts.eduSessionId)
    if (opts.customEduTitle) fd.append('custom_edu_title', opts.customEduTitle)
    for (const f of opts.files) fd.append('files', f)
    return api.post<ImportRecord>(
      `/imports/sites/${siteId}`, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then(r => r.data)
  },

  listBySite: (siteId: string) =>
    api.get<ImportRecord[]>(`/imports/sites/${siteId}`).then(r => r.data),

  get: (importId: string) =>
    api.get<ImportRecord>(`/imports/${importId}`).then(r => r.data),

  updateRows: (importId: string, rows: any[]) =>
    api.put<ImportRecord>(`/imports/${importId}/rows`, { rows }).then(r => r.data),

  apply: (importId: string) =>
    api.post<ApplyResult>(`/imports/${importId}/apply`).then(r => r.data),

  remove: (importId: string) =>
    api.delete(`/imports/${importId}`).then(() => undefined),
}
